<template>
  <b-modal
    :ok-title-html="modalsubmit == true ? loaderIcon + 'Save' : 'Save'"
    :ok-disabled="modalsubmit"
    @ok="handleSubmit"
    id="ConfigUnit"
    ref="ConfigUnit"
    size="md"
    ok-title="Save"
    :title="'Configure Units'"
    :no-close-on-backdrop="true"
    cancel-variant="light"
    body-class="bg-white"
    @shown="unit_list_values = JSON.parse(JSON.stringify(unit_list))"
    scrollable
  >
    <div style="overflow-x: hidden">
      <b-row class="mt-2 px-pad">
        <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
          <div class="container-fluid">
            <b-alert
              class="alert-transparent alert-danger"
              :show="error_show && (errors.any() || error_msg != '')"
            >
              <button
                type="button"
                @click="error_show = !error_show"
                class="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p class="fw-semi-bold">{{ error_msg }}</p>
              <p
                class="fw-semi-bold"
                v-for="(item, index) in errors.items"
                :key="item.id"
                v-if="item.scope == 'custom-unit' && index == 0"
              >
                {{ item.msg }}
              </p>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-form data-vv-scope="custom-unit">
        <b-row class="my-2">
          <b-col cols="5">
            Unit
            <span class="text-danger">*</span>
          </b-col>
          <b-col cols="5">
            UQC
            <span
              class="fa fa-info-circle"
              v-b-tooltip.top="'Unique Quantity Code ( UQC )'"
            ></span>
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>
        <b-row
          class="my-1"
          v-for="(unit, index) in unit_list_values"
          :key="index"
        >
          <b-col cols="5">
            <b-input
              data-vv-name="unit_name"
              data-vv-as="unit name"
              v-validate="{ max: 120, required: unit.unit_id }"
              v-model="unit.label"
            ></b-input>
          </b-col>
          <b-col cols="5">
            <v-select
              :clearable="unit.unit_id != '' && unit.unit_id != null"
              @input="$event = null ? (unit.unit_id = '') : ''"
              size="sm"
              :options="gnl_unit_list"
              label="label"
              index="value"
              id="pdt_unit-select"
              data-vv-name="unit value"
              name="pdt_unit"
              v-model.trim="unit.unit_id"
            ></v-select>
          </b-col>
          <b-col cols="2">
            <i
              @click="removeRow(index)"
              class="la la-trash text-danger cursor_pointer la-lg"
            ></i>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <span @click="addNewRow()" class="text-primary cursor_pointer"
              >Add New</span
            >
          </b-col>
        </b-row>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import vSelect from "vue-select"; // vue seatch select component
import { mapGetters, mapState } from "vuex"; // get data set in the state in vuex
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification

export default {
  components: {
    vSelect,
  },
  mixins: [notificationMixin],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      message: "",
      modalsubmit: false,
      unit_list_values: [],
      error_show: false,
      error_msg: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
    };
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  methods: {
    async handleSubmit(evt) {
      await evt.preventDefault();

      this.modalsubmit = await true;
      // this.unit_list_values = await this.unit_list_values.filter(
      //   (x) => x.unit_id != ""
      // );
      //update reporting tag field values to item

      this.$validator.validateAll("custom-unit").then((result) => {
        if (result) {
          this.$store
            .dispatch("products/customizeunits", {
              unit_list: this.unit_list_values,
              old_unit_ids: this.old_unit_ids,
            })
            .then((response) => {
              this.modalsubmit = false;
              this.error_show = false;
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: response.data.status,
                type: response.data.type,
                showCloseButton: true,
              });
              if (response.status == 200) {
                this.unit_list = response.data.unit_list;
                this.$refs.ConfigUnit.hide();
                this.$emit("customizedUnit");
              }
            });
        } else {
          this.modalsubmit = false;
          this.error_show = true;
        }
      });
    },
    addNewRow() {
      this.unit_list_values.push({
        unit_id: "",
        label: "",
        value: "",
      });
    },
    removeRow(index) {
      this.unit_list_values.splice(index, 1);
    },
  },
  computed: {
    unit_list: {
      get() {
        return this.$store.state.products.unit_list;
      },
      set(val) {
        this.$store.state.products.unit_list = val;
      },
    },
    ...mapState({
      gnl_unit_list: (state) => state.products.gnl_unit_list,
      old_unit_ids: (state) => state.products.old_unit_ids,
    }),
    ...mapGetters(["reporting_tags"]),
  },
};
</script>
